/**
 * @module utils/never
 */

import resolvable from './resolvable.js'

const [never] = resolvable()

/**
 * A common promise which never resolves
 * @type {Promise<*>}
 */
export default never
